import React from 'react';
import { motion } from 'framer-motion';
import { FaRobot } from 'react-icons/fa';
import { Link } from 'react-router-dom'; // Assuming you're using react-router

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: 1 }
  },
};

const iconVariants = {
  animate: {
    rotate: [0, 360],
    transition: {
      repeat: Infinity,
      duration: 10,
      ease: 'linear',
    },
  },
};

const textVariants = {
  hidden: { y: 50, opacity: 0 },
  visible: (custom: number) => ({
    y: 0,
    opacity: 1,
    transition: { delay: custom * 0.2, duration: 0.6 },
  }),
};

const NotFoundPage: React.FC = () => {
  return (
    <motion.div
      className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 px-4"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <motion.div
        className="text-white text-6xl mb-4"
        variants={iconVariants}
        animate="animate"
      >
        <FaRobot />
      </motion.div>

      <motion.h1
        className="text-4xl md:text-6xl font-bold text-center text-white mb-4"
        variants={textVariants}
        initial="hidden"
        animate="visible"
        custom={1}
      >
        Oops! Page Not Found
      </motion.h1>

      <motion.p
        className="text-lg md:text-2xl text-center text-white mb-8 max-w-md"
        variants={textVariants}
        initial="hidden"
        animate="visible"
        custom={2}
      >
        It seems like the AI took a wrong turn. Let us guide you back to safety.
      </motion.p>

      <motion.div
        variants={textVariants}
        initial="hidden"
        animate="visible"
        custom={3}
      >
        <Link to="/" className="inline-block px-6 py-3 bg-white text-indigo-600 font-semibold rounded-full shadow-lg hover:bg-gray-100 transition">
          Go Back Home
        </Link>
      </motion.div>

      {/* Decorative Floating Elements */}
      <motion.div
        className="absolute top-10 left-10 w-12 h-12 bg-white bg-opacity-20 rounded-full"
        initial={{ y: -100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 1, duration: 1 }}
      />
      <motion.div
        className="absolute bottom-20 right-10 w-16 h-16 bg-white bg-opacity-10 rounded-full"
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 1.5, duration: 1 }}
      />
      <motion.div
        className="absolute top-1/2 left-1/4 w-20 h-20 bg-white bg-opacity-15 rounded-full"
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 2, duration: 1 }}
      />
    </motion.div>
  );
};

export default NotFoundPage;
